<div class="wrapper__headerComponent container my-5">
  <div class="contenedor-tabla w-100">
    <div class="d-flex flex-row justify-content-between mb-5">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{
          esSuperAdmin
            ? ('gestion-usuarios.lideres' | translate)
            : ('gestion-usuarios.funcionales' | translate)
        }}
      </h2>
      <div>
        <button
          class="btn-govco outline-btn-govco"
          (click)="crearAdministrador()"
          aria-label="Agregar administrador">
          <i class="govco-plus-square-1"></i>
          {{ 'gestion-usuarios.agregar' | translate }}
        </button>
      </div>
    </div>
    <!-- Administrador Líder -->
    <app-table
      *ngIf="esSuperAdmin"
      [datos]="administradoresLideres"
      [columnas]="columnasAdminLider"
      [paginacion]="true"
      [paginaActual]="paginaActualLider"
      [totalPaginas]="totalPaginasLider"
      [tamano]="tamanoPaginaLider"
      (evento)="buscarLideres($event)"
      [multipleSelection]="true"
      (selectedItemsChange)="verificarSeleccion($event)"
      [idColumn]="'id'"></app-table>
    <!-- Administrador Funcional -->
    <app-table
      *ngIf="esAdminLider"
      [datos]="administradoresFuncionales"
      [columnas]="columnasAdminFuncional"
      [paginacion]="true"
      [paginaActual]="paginaActualFuncional"
      [totalPaginas]="totalPaginasFuncional"
      [tamano]="tamanoPaginaFuncional"
      (evento)="buscarFuncionales($event)"
      [multipleSelection]="true"
      [idColumn]="'id'"
      (selectedItemsChange)="verificarSeleccion($event)"></app-table>
    <app-table
      *ngIf="esAdminLiderMjd"
      [datos]="administradoresFuncionales"
      [columnas]="columnasAdminFuncional"
      [paginacion]="true"
      [paginaActual]="paginaActualFuncional"
      [totalPaginas]="totalPaginasFuncional"
      [tamano]="tamanoPaginaFuncional"
      (evento)="buscarFuncionalesMjd($event)"
      [multipleSelection]="true"
      [idColumn]="'id'"
      (selectedItemsChange)="verificarSeleccion($event)"></app-table>
    <div class="d-flex flex-row justify-content-end my-3">
      <div>
        <button
          class="btn-govco outline-btn-govco me-2"
          [disabled]="!usuarioSeleccionado"
          (click)="modificarAdministrador()"
          aria-label="Modificar administrador">
          <i class="govco-edit-1"></i>
          {{ 'gestion-usuarios.modificar' | translate }}
        </button>
      </div>
      <div>
        <button
          class="btn-govco outline-btn-govco"
          [disabled]="!usuarioSeleccionado"
          (click)="eliminarUsuario()"
          aria-label="Eliminar administrador">
          <i class="govco-trash"></i>
          {{ 'gestion-usuarios.eliminar' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
